module.exports = __webpack_public_path__ + "static/media/angel.58a65594.png";